import React,{useState,useEffect} from "react";
import KioskLayout from "components/Layout/KioskLayout";
import KioskMenuList from "components/Kiosk/Home/KioskMenuList";
import KioskHomeBanner from "components/Kiosk/Home/KioskHomeBanner";
import KioskEnvironment from "components/Kiosk/Home/KioskEnvironment";
import FilterSection from "components/shared/FilterSection";
import MapRouterMaster from "containers/MapRouterMaster";
import useFetch from "hooks/useFetch";
import useGetFloorLvl from "hooks/useGetFloorLvl";
import useGaPageView from "hooks/useGaPageView";
import { useSelector,useDispatch } from "react-redux";
import { mainApiPath } from "api/constants";
import { mapRouterType, gaSettings } from "config/constants";
import { facility, facilityName, facilityIcon, facilityTags } from "config/facilities";
import Axios from "axios";
import QrImage from "../../../assets/images/enviroment.7f9af740.jpg";


const KioskHome = () => {
  const dispatch = useDispatch()
  const onScreenSaverMode = useSelector((state) => state.onScreenSaverMode);
  const langState = useSelector((state) => state.language.lang);
  const [error, loading, data] = useFetch(mainApiPath.menu);
  const floorLevel = useGetFloorLvl();
  const [keySearch,setKeySearch] = useState({})

  const gaTitle = gaSettings.kiosk.title;
  const gaLocation = gaSettings.kiosk.location;
  useGaPageView({gaTitle, gaLocation});
  useEffect(() => {
    async function fetchKeySearch() {
      try {
        const data = await Axios.get(`${process.env.REACT_APP_API_URL}/kiosk/facility/key-search`)
        const facilityTag = data.data
        setKeySearch(facilityTag)
      } catch(e) {}
    }
    fetchKeySearch()
    
    if(keySearch){
      const facilities = Object.keys(facility).map((f) => {
        return {
          type: facility[f],
          title: facilityName[f][langState],
          icon: facilityIcon[f],
          tags : keySearch[f]
        };
      });
      dispatch({type:"SET_FACILITIES",payload:facilities})
    }
  },[keySearch?.elevators])

  return (
    <>
      <KioskLayout
        error={error}
        loading={loading}
        left={
          <>
            <MapRouterMaster
              type={mapRouterType.overview}
              floorIndex={floorLevel}
              layout={"kiosk"}
              
            />
            <FilterSection
              floors={data ? data.floors : null}
              search
              floorfilter
              home
              loading={loading}
              
            />
          </>
        }
        right={
          <>
            <KioskMenuList
              menus={data ? data.categories : null}
              loading={loading}
            />
            <div className="row" style={{marginLeft: "-10px", marginRight: "-10px"}}>
              <div className="col-6" style={{paddingLeft: "10px", paddingRight: "10px"}}>
                <div className="dot">
                  <KioskHomeBanner
                    banners={data ? data.banners : null}
                    loading={loading}
                  />
                </div>
              </div>
              <div className="col-6" style={{paddingLeft: "10px", paddingRight: "10px"}}>
                {/* {!onScreenSaverMode && <KioskEnvironment loading={loading} />} */}
                <img style={{ width: '100%', borderRadius: '8px' }} src={QrImage} />
              </div>
            </div>
          </>
        }
      />
    </>
  );
};

export default KioskHome;
